import React, { useState, useEffect } from 'react';
import {
  FluentProvider,
  teamsLightTheme,
  Button,
  Textarea,
  Spinner,
} from '@fluentui/react-components';
import { Warning24Regular, ArrowSync24Regular } from '@fluentui/react-icons';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchTranscript, createDraftNotes } from "../services/TranscriptionService";
import * as microsoftTeams from "@microsoft/teams-js";

const ObservationForm = () => {
  const [additionalNotes, setAdditionalNotes] = useState("Value");
  const [userId, setUserId] = useState("");
  const [chatId, setChatId] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

    const selectedForm = location.state?.selectedForm || { id: 0, surveyCodedId: "", name: "" };
  const referenceCode = location.state?.referenceCode || "";

  useEffect(() => {
    microsoftTeams.initialize();
    microsoftTeams.getContext((context) => {
      setUserId((context as any)?.userObjectId || "");
      setChatId((context as any)?.chatId || "");
    });
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const transcript = await fetchTranscript(userId, chatId);
      const smartTemplateId = selectedForm.id;
      const smartTemplateCodedId = selectedForm.surveyCodedId;
      await createDraftNotes(chatId, transcript, additionalNotes, smartTemplateId, smartTemplateCodedId);
      navigate("/success-screen", { state: { selectedForm, referenceCode } });
    } catch (error) {
      console.error("Error submitting transcript:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FluentProvider theme={teamsLightTheme}>
      <div style={{ padding: 20, maxWidth: 400, minHeight: '90vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
        <div>
          <Button appearance="subtle" icon={<span style={{display:'inline-block',transform:'rotate(180deg)'}}>&#8594;</span>} onClick={() => navigate(-1)} aria-label="Back" />
        </div>
          <div style={{ marginTop: 16 }}>
            <div style={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
              Health Partners Transcript Assistant
            </div>
            <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>
              {referenceCode}
            </div>
            <div style={{ fontWeight: 600, marginTop: 4 }}>{selectedForm.name}</div>
          </div>

          <div
            style={{
              backgroundColor: '#FFF4E5',
              color: '#8A4500',
              borderRadius: 6,
              padding: '12px',
              display: 'flex',
              alignItems: 'start',
              gap: 8,
              marginTop: 16,
              fontSize: '0.875rem',
              border: '1px solid #F5C29F',
            }}
          >
            <Warning24Regular />
            <div>
              <strong>Warning</strong><br />
              Only generate notes at the end of the meeting. Notes can not be re-generated.
            </div>
          </div>

          <div style={{ marginTop: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>Additional Observations</div>
            <Textarea
              defaultValue={additionalNotes}
              resize="vertical"
              style={{ width: '100%' }}
              onChange={(e) => setAdditionalNotes(e.target.value)}
            />
          </div>
        </div>

        <div style={{ marginTop: 24, textAlign: 'center' }}>
          {loading ? (
            <Spinner size="medium" label="Submitting..." />
          ) : (
            <Button appearance="primary" icon={<ArrowSync24Regular />} iconPosition="before" onClick={handleSubmit}>
              Submit
            </Button>
          )}
        </div>
      </div>
    </FluentProvider>
  );
};

export default ObservationForm;
